import { render, staticRenderFns } from "./PuzzlePage.vue?vue&type=template&id=6c8372b8&scoped=true"
import script from "./PuzzlePage.vue?vue&type=script&lang=js"
export * from "./PuzzlePage.vue?vue&type=script&lang=js"
import style0 from "./PuzzlePage.vue?vue&type=style&index=0&id=6c8372b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8372b8",
  null
  
)

export default component.exports